import { useEffect, useState } from "react";
import textWeight from "../../utils/textWeight";
import Countries from "../../js/countrydata";
export default (defaultValue, countryCode, setCountryCode, cca2, setCca2) => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [phoneDigits, setPhoneDigits] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const { TextWeight } = textWeight();
  useEffect(() => {
    // console.log("📱 PhoneNumberInput initialization:");
    // console.log("defaultValue:", defaultValue);
    // console.log("countryCode:", countryCode);
    // console.log("cca2", cca2, "countryCode:", countryCode, "selectedCountry", selectedCountry, "defaultValue", defaultValue);
    if (defaultValue || cca2 || countryCode) {
      let country = null;
      if (cca2) {
        // First try to match by country code (e.g., "PK")
        country = Countries?.find(
          (c) => c.code === cca2
        );
        
        // console.log("Found by dial code:", country?.name);
        
        // If not found, try to match by country code (e.g., "PK")
        if (!country) {
          country = Countries?.find(
            (c) => cca2.toUpperCase() === c.code.toUpperCase()
          );
          // console.log("Found by country code:", country?.name);
        }
      }      
      else if (countryCode) {
        // First try to match by dial code (e.g., "+92")
        country = Countries?.find(
          (c) => c.dialCode === countryCode
        );
        
        // console.log("Found by dial code:", country?.name);
        
        // If not found, try to match by country code (e.g., "PK")
        if (!country) {
          country = Countries?.find(
            (c) => countryCode.toUpperCase() === c.code.toUpperCase()
          );
          // console.log("Found by country code:", country?.name);
        }
      } else if (defaultValue) {
        country = Countries?.find((c) => defaultValue.startsWith(c.dialCode));
        // console.log("Found by defaultValue:", country?.name);
      }

      if (country) {
        const digits =
          defaultValue && defaultValue.startsWith(country.dialCode)
            ? defaultValue.replace(country.dialCode, "").trim()
            : defaultValue || "";
        
        // console.log("✅ Setting country:", country.name);
        // console.log("✅ Phone digits:", digits);
        // console.log("✅ Input value:", `${country.dialCode} ${digits}`);
        
        setSelectedCountry(country);
        setPhoneDigits(digits);
        setInputValue(`${country.dialCode} ${digits}`);
      } else {
        console.log("❌ No country found!");
      }
    }
  }, [defaultValue, countryCode]);

  const filteredCountries = Countries?.filter(
    (country) => country.name.toLowerCase().includes(inputValue.toLowerCase())
    // || country.dialCode.toLowerCase().includes(inputValue.toLowerCase())
  );

  const handleInputChange = (value, onChange) => {
    setInputValue(value);

    // If country is selected, process phone number input
    if (selectedCountry) {
      // Remove country code if user types it again
      const cleanValue = value.replace(selectedCountry.dialCode, "").trim();
      const digits = cleanValue.replace(/\D/g, "").slice(0, 10);
      setPhoneDigits(digits);
      setCountryCode(selectedCountry.dialCode); // ✅ Set dial code like "+92" instead of "PK"
      setCca2(selectedCountry.code);
      onChange(`${selectedCountry.dialCode} ${digits}`);
      return;
    }

    // Show dropdown when searching for country
    setShowDropdown(true);

    // Check if input matches any country code exactly
    const matchedCountry = Countries?.find((country) =>
      value.startsWith(country.dialCode)
    );

    if (matchedCountry) {
      // Extract phone digits after country code
      const phoneValue = value.replace(matchedCountry.dialCode, "").trim();
      const digits = phoneValue.replace(/\D/g, "").slice(0, 15);

      setSelectedCountry(matchedCountry);
      setPhoneDigits(digits);
      setInputValue(`${matchedCountry.dialCode} ${digits}`);
      onChange(`${matchedCountry.dialCode} ${digits}`);
      setShowDropdown(false);
      return;
    }

    // No country match found yet
    onChange(value);
  };

  const selectCountry = (country, onChange) => {
    setSelectedCountry(country);
    setPhoneDigits("");
    setInputValue(country.dialCode + " "); // Show code with space
    setCountryCode(country.dialCode); // ✅ Set dial code like "+92" instead of "PK"
    setCca2(country.code);
    setShowDropdown(false);
    onChange(`${country.dialCode} `);
    console.log("cca2-110", cca2, "countryCode:", countryCode, country.code);
  };
  return {
    selectedCountry,
    setSelectedCountry,
    phoneDigits,
    setPhoneDigits,
    inputValue,
    setInputValue,
    showDropdown,
    setShowDropdown,
    filteredCountries,
    handleInputChange,
    selectCountry,
    TextWeight,
    Countries, 
  };
};